import { defineStore } from 'pinia'
import { useMembersStore } from './members.store'
import { useTeamsStore } from './teams.store'
import { useUserStore } from './user.store'
import { useNotificationStore } from './notification.store'
import { Permission } from '../core/models/user'

export const useInitializationStore = defineStore('initialization', {
  state: () => ({
    initializationState: InitializationState.Uninitialized,
  }),
  actions: {
    async setInitializationState(state: InitializationState) {
      this.initializationState = state
    },
    async intializeStores() {
      try {
        this.initializationState = InitializationState.Initializing

        const userStore = useUserStore()
        const membersStore = useMembersStore()
        const teamsStore = useTeamsStore()
        const notificationsStore = useNotificationStore()

        await userStore.loadUser()
        await membersStore.initialize()
        if (userStore.user.memberPermissions.includes(Permission.TEAM_VIEW_MEMBERS)) {
          await teamsStore.initialize()
        }
        await notificationsStore.initialize()

        this.initializationState = InitializationState.Initialized
        return
      } catch (error) {
        this.initializationState = InitializationState.Error
        console.error(error)
        return
      }
    },
  },
})

export enum InitializationState {
  Uninitialized = 'unintialized',
  Initializing = 'initializing',
  Initialized = 'initialized',
  Error = 'error',
}
